import { render, staticRenderFns } from "./SideStateLegEmpty.vue?vue&type=template&id=2cc4ae84&scoped=true"
import script from "./SideStateLegEmpty.vue?vue&type=script&lang=js"
export * from "./SideStateLegEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4ae84",
  null
  
)

export default component.exports